import * as React from "react";
import { useNavigate } from "react-router-dom"; 
import { Field, Form, Formik } from "formik";
import { WalletTransferController } from "@njoy/controller";
import { ToastContainer } from "react-toastify";
import moment from "moment";

import { TemplateSub } from "../../components/layouts/TemplateSub";
import NewButton from "../../components/uiMerge/newButton";
import chickenIcon from "../../assets/images/successNewIcon.svg";
import { TransactionSuccessfulModal } from "../../components/modals/transactionSuccessModal";
import { InputPinField } from "../shared/InputPinField";
import "react-toastify/dist/ReactToastify.css";
import ToastMessage from "../../hooks/useToast";
import * as ROUTES from "../../constants/routes";
import { requestPushPromptForAction } from "../../utils/pushNotifications";

interface PinFormValues {
  pin: string;
}

export const ConfirmTransactionViewWallet: React.FC = (props) => {
  const navigate = useNavigate();
  const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
  const [responseMessage, setResponseMessage] = React.useState("");
  const [recipientName, setRecipientName] = React.useState("");
  const [transactionDate, setTRansactionDate] = React.useState("");
  const [transactionAmount, setTransactionAmount] = React.useState(0);
  const [currentCurrency, setCurrentCurrency] = React.useState("");

  const handleClose = () => {
    setOpenSuccessModal(false);
    navigate(ROUTES.VIEW_WALLET)
  };

  function formatWalletBalance(balance: number): string {
    return balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return (
    <WalletTransferController>
      {({submitWalletTransfer,}) => (
        <TemplateSub page={"Confirm Transaction"}>
          <>
            <ToastContainer />

            <Formik<PinFormValues>
              initialValues={{ pin: "" }}
              onSubmit={async (values, { setSubmitting, setErrors }) => {
                setSubmitting(true);
                
                if(values.pin.length < 4) {
                  setErrors({ pin: "Pin must be 4 digits" });
                  setSubmitting(false);
                  return;
                }
                
                const amount = localStorage.getItem("amount") || "";
                const barterId = localStorage.getItem("barterId") || "";
                const narration = localStorage.getItem("narration") || "";
                const currency = localStorage.getItem("currency") || "";
                const response = await submitWalletTransfer({
                  input: {
                    pin: values.pin,
                    barterId,
                    amount: parseFloat(`${amount}`),
                    currency,
                    narration
                  }
                })

                if(response.walletTransfer) {
                  setResponseMessage(response.walletTransfer.message || "");
                  setRecipientName(response.walletTransfer.data.full_name);
                  setTransactionAmount(response.walletTransfer.data.amount || 0);
                  setTRansactionDate(response.walletTransfer.data.created_at || "");
                  setCurrentCurrency(response.walletTransfer.data.currency || "");
                  // console.log("res message ", message)
                  // console.log("wallet transfer res ", walletTransferData);
                  localStorage.removeItem("amount");
                  localStorage.removeItem("barterId");
                  localStorage.removeItem("narration");
                  localStorage.removeItem("currency");
                  requestPushPromptForAction("wallet-transfer-success");
                  setOpenSuccessModal(true);
                } else if(response.error) {
                  // console.log("err ", response)
                  ToastMessage("error", 
                    response.error.user || 
                    response.error.pin || 
                    response.error.wallet
                  );
                }

              }}
            >
              {({ isSubmitting, handleSubmit }) => (
                <Form
                onSubmit={handleSubmit}
                className="flex flex-col px-[1rem] gap-40 mt-24 flex-1">
                  <div>
                     <p className="w-full mb-4 text-[#EAEAEA] text-[16px] text-center">
                      Input Your Pin
                    </p>

                    <Field
                    name="pin"
                    component={InputPinField}
                    otpLength={4} />
                  </div>

                  <div className="mt-44">
                    <NewButton
                    loading={isSubmitting}
                    fullWidth
                    variant="primary"
                    type="submit"
                    className="login-form-button">
                      Confirm Payment
                    </NewButton>
                  </div>
                </Form>
              )}
            </Formik>

            <TransactionSuccessfulModal
              isFreebie={false}
              amount={`${currentCurrency} ${formatWalletBalance(transactionAmount)}`}
              isOpen={openSuccessModal}
              onClose={handleClose}
              offerType={"Successful"}
              title={responseMessage}
              icon={chickenIcon}
              name={recipientName}
              redeemedAt={moment(transactionDate).format("MMMM D YYYY")}
              redeemedTime={moment(transactionDate).format("hh:mm A")}
              recipientType={"User"}
            />
          </>
        </TemplateSub>
      )}
    </WalletTransferController>
  );
};
